<template>
	<div
		role="menu"
		class="d-flex flex-column rounded-2 overflow-hidden bg-white border-xs border-neutral-100"
	>
		<slot />
	</div>
</template>
